var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#0b111a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4895 32.3077C62.7863 47.7996 67.0451 62.3666 72.3709 70.639C74.1332 73.0631 74.0569 73.0293 76.5676 76.2054C76.9773 76.7325 77.387 77.2738 77.7967 77.8294C84.6513 86.4662 88.4767 96.2433 80.2163 111.558C102.671 87.1945 75.1382 60.824 71.4895 32.3077Z",
    fill: "url(#paint0_linear_5566_196362)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7466 54.301C60.3424 77.1072 65.1918 77.6105 74.3714 85.5523C83.4175 93.1926 81.8308 103.08 79.0541 111.678C95.1788 82.5869 66.5976 73.7874 57.7472 54.301H57.7466Z",
    fill: "url(#paint1_linear_5566_196362)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.115 116.333C47.8105 114.474 38.2595 104.214 32.6239 91.3707C32.5098 113.636 58.3705 122.407 76.3007 115.255C74.3764 115.84 72.3375 116.256 70.2607 116.476C67.5502 116.768 64.7729 116.735 62.115 116.333Z",
    fill: "url(#paint2_linear_5566_196362)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2192 101.369C48.7722 115.922 66.6066 118.125 78.1344 113.589C64.3915 117.636 53.3975 112.037 47.2192 101.369Z",
    fill: "url(#paint3_linear_5566_196362)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.278 77.7456C105.327 76.3715 103.681 73.9961 102.3 71.0544C102.024 73.5575 102.085 76.0943 103.452 77.9813C100.901 78.6134 98.3786 80.0231 96.251 82.1154C96.9273 92.7211 94.8505 102.675 84.2993 110.655C102.229 101.439 99.6189 88.3186 107.24 85.0849C111.041 83.3607 114.624 84.7834 117.377 88.8546C116.498 81.9836 112.727 78.4721 108.278 77.745V77.7456Z",
    fill: "url(#paint4_linear_5566_196362)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.483 36.5967C84.3804 45.5499 79.5405 50.4693 84.7659 68.3081C89.4148 80.2356 92.3825 91.7708 87.2287 102.975C86.19 105.408 84.7517 107.789 82.8369 110.098L82.8133 110.127C82.5277 110.471 82.2274 110.816 81.9224 111.161C109.927 92.2682 84.1659 60.4226 92.483 36.5961V36.5967Z",
    fill: "url(#paint5_linear_5566_196362)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5566_196362",
    x1: 69.7045,
    y1: 29.4536,
    x2: 85.2013,
    y2: 112.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5566_196362",
    x1: 53.5643,
    y1: 54.301,
    x2: 78.169,
    y2: 111.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5566_196362",
    x1: 54.4621,
    y1: 91.3707,
    x2: 54.4621,
    y2: 117.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5566_196362",
    x1: 62.6768,
    y1: 101.369,
    x2: 62.6768,
    y2: 115.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5566_196362",
    x1: 112.411,
    y1: 60.2092,
    x2: 93.111,
    y2: 104.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5566_196362",
    x1: 90.422,
    y1: 37.9968,
    x2: 84.5106,
    y2: 109.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage);
export default __webpack_public_path__ + "static/media/placeholder_image.06a0a234b68f3959ec49813349f16944.svg";
export { ForwardRef as ReactComponent };